import { submitted } from "../actions/ui/forms";

const onSubmit = dispatch => (id, action) => event => {
  event.preventDefault();
  dispatch(submitted(id, action));
};

const ReduxSubmitter = function() {
  this.init = dispatch => {
    this.dispatch = dispatch;
    this.onSubmit = onSubmit(dispatch);
  };
};

export const localSubmit = handler => event => {
  event.preventDefault();
  handler();
};

export default new ReduxSubmitter();



// WEBPACK FOOTER //
// ./src/sc/helpers/redux-submit.js